/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import {
    IconBlockquote,
    IconBold,
    IconItalic,
    IconStrikethrough,
    IconUnderline,
} from "@tabler/icons-react";
import { ToolbarButton } from "./toolbar-button/toolbar-button";
import { ToolbarButtonColor } from "./toolbar-button/toolbar-button-color";
import { ToolbarButtonGroup } from "./toolbar-button/toolbar-button-group";
import { useTranslation } from "react-i18next";
import { useFeatureFlag } from "cms/features/use-feature-flag";

/**
 * @param {object} props
 * @param {boolean=} props.floating
 */
const MarkButtons = (props) => {
    
    const { floating = false } = props;
    const { t } = useTranslation();
    const colorFeatureEnabled = useFeatureFlag("feature_rich_text_colour");

    /** @type {import("@mui/material").ButtonGroupProps }*/
    const buttonGroupProps = {};

    if (floating) {
        buttonGroupProps.variant = "contained";
    }

    return (
        <ToolbarButtonGroup {...buttonGroupProps}>
            <ToolbarButton
                command="toggleBold"
                icon={IconBold}
                activeAttribute="bold"
                tooltip={t("Editor.bold")}
            />
            <ToolbarButton
                command="toggleItalic"
                icon={IconItalic}
                activeAttribute="italic"
                tooltip={t("Editor.italic")}
            />
            <ToolbarButton
                command="toggleUnderline"
                icon={IconUnderline}
                activeAttribute="underline"
                tooltip={t("Editor.underline")}
            />
            <ToolbarButton
                command="toggleStrike"
                icon={IconStrikethrough}
                activeAttribute="strike"
                tooltip={t("Editor.strike")}
            />
            <ToolbarButton
                command="toggleBlockquote"
                icon={IconBlockquote}
                activeAttribute="blockquote"
                tooltip={t("Editor.blockquote")}
            />
            <ToolbarButton
                command="toggleBlockquote"
                icon={IconBlockquote}
                activeAttribute="blockquote"
                tooltip={t("Editor.blockquote")}
            />
            {colorFeatureEnabled &&
                <ToolbarButtonColor
                    activeAttribute="textStyle"
                    tooltip={t("Editor.textColor")}
                />
            }
        </ToolbarButtonGroup>
    );
};
export { MarkButtons };
